
export const frodoMediaArray = [
  {
    _id: 'frodoMediaId1',
    userId: 'frodoUserId',
    email: 'frodo@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-1-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-1-p.png`,
    description: ``,
    captions: [
      `Me in the wild`,
      `#MondaysAmIRight?`,
      `Me and my best friend`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'frodoMediaId2',
    userId: 'frodoUserId',
    email: 'frodo@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-2-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-2-p.png`,
    description: ``,
    captions: [
      `Me in my blogging days`,
      `My best blue steel`,
      `Plandid or candid?`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'frodoMediaId3',
    userId: 'frodoUserId',
    email: 'frodo@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-3-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-3-p.png`,
    description: ``,
    captions: [
      `Me during Fashion Week`,
      `As seen on my Mom's fridge`,
      `My life behind the scenes`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'frodoMediaId4',
    userId: 'frodoUserId',
    email: 'frodo@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-4-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-4-p.png`,
    description: ``,
    captions: [
      `#MondaysAmIRight?`,
      `Don't show this to my mom`,
      `Let me introduce you to my alter ego`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'frodoMediaId5',
    userId: 'frodoUserId',
    email: 'frodo@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-5-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-5-p.png`,
    description: ``,
    captions: [
      `Dating me will look like`,
      `As seen on my mom's fridge`,
      `My good side`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'frodoMediaId6',
    userId: 'frodoUserId',
    email: 'frodo@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-6-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-6-p.png`,
    description: ``,
    captions: [
      `As seen on my mom's fridge`,
      `Dating me will look like`,
      `My good side`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'frodoMediaId7',
    userId: 'frodoUserId',
    email: 'frodo@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-7-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-7-p.png`,
    description: ``,
    captions: [
      `Dating me will look like`,
      `As seen on my mom's fridge`,
      `My good side`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'frodoMediaId8',
    userId: 'frodoUserId',
    email: 'frodo@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-8-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-8-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `Me in my blogging days`,
      `Felt cute might delete later`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'frodoMediaId9',
    userId: 'frodoUserId',
    email: 'frodo@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-9-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-9-p.png`,
    description: ``,
    captions: [
      `I thought I deleted this one`,
      `Don't judge me`,
      `The moment I knew my modeling career was over`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'frodoMediaId10',
    userId: 'frodoUserId',
    email: 'frodo@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-10-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-10-p.png`,
    description: ``,
    captions: [
      `I'm known for`,
      `How history will remember me`,
      `Me and my best friend`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'frodoMediaId11',
    userId: 'frodoUserId',
    email: 'frodo@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-11-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-11-p.png`,
    description: ``,
    captions: [
      `How history will remember me`,
      `Lowkey flex`,
      `Me in the wild`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'frodoMediaId12',
    userId: 'frodoUserId',
    email: 'frodo@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-12-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-12-p.png`,
    description: ``,
    captions: [
      `You had to be there`,
      `Guess the backstory of this photo`,
      `How history will remember me`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'frodoMediaId13',
    userId: 'frodoUserId',
    email: 'frodo@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-13-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-13-p.png`,
    description: ``,
    captions: [
      `I'm known for`,
      `How history will remember me`,
      `My proudest moment`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'frodoMediaId14',
    userId: 'frodoUserId',
    email: 'frodo@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-14-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-14-p.png`,
    description: ``,
    captions: [
      `Guess the backstory of this photo`,
      `You had to be there`,
      `How history will remember me`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  }
]